import(/* webpackMode: "eager" */ "/tmp/8de3bd17dbe0d82/components/ui/Section.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8de3bd17dbe0d82/components/ui/Container.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8de3bd17dbe0d82/components/ui/Heading.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8de3bd17dbe0d82/components/ui/Text.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8de3bd17dbe0d82/app/[locale]/partners/[slug]/partner.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8de3bd17dbe0d82/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/tmp/8de3bd17dbe0d82/node_modules/next/dist/client/link.js");
